import { useState, useMemo } from 'react'
import { Modal, Select, Button } from '@mantine/core'
import Box from '@/components/ui/Box'
import useSWR from 'swr'
import { useAxiosApi } from '@/hooks/useAxiosApi'

export default function ServiceCaseProduct({ serviceCase, updateServiceCase }) {
    const [opened, setOpened] = useState(false)
    const [value, setValue] = useState(null)
    const [loading, setLoading] = useState(false)
    const { requestGet } = useAxiosApi()

    // Fetch components only when modal is opened
    const { data: { data: components = [] } = {} } = useSWR(
        opened ? '/service-cases/product-references' : null,
        requestGet
    )

    const selectData = useMemo(() => {
        const items = [{ value: 'accessories', label: 'Accessoires' }]
        if (Array.isArray(components) && components.length) {
            items.push(...components.map((c) => ({ value: c.value, label: c.label })))
        }
        return items
    }, [components])

    const handleOpen = () => {
        setValue(serviceCase.component_id ? String(serviceCase.component_id) : 'accessories')
        setOpened(true)
    }

    const handleSubmit = async () => {
        setLoading(true)
        await updateServiceCase({ component_id: value === 'accessories' ? null : Number(value) })
        setLoading(false)
        setOpened(false)
    }

    return (
        <>
            <Box
                title="Produit"
                globalAction={true}
                action={handleOpen}
                actionLabel="Modifier le produit"
            >
                <span className={serviceCase.product_name ? '' : 'text-gray-400'}>
                    {serviceCase.product_name || 'Non renseigné'}
                </span>
            </Box>

            <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                title="Modifier le produit"
                centered
            >
                <div className="flex flex-col gap-3">
                    <Select
                        label="Produit"
                        placeholder="Rechercher un produit..."
                        searchable
                        data={selectData}
                        value={value}
                        onChange={setValue}
                        maxDropdownHeight={300}
                    />
                    <Button fullWidth mt="sm" onClick={handleSubmit} loading={loading}>
                        Enregistrer
                    </Button>
                </div>
            </Modal>
        </>
    )
}
